import { SxProps, Theme } from "@/common/styles/style";

export const styles: {
  [key: string]: SxProps<Theme>;
} = {
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  table: { width: "90%" },
  tableCell: {
    padding: 0.5,
  },
  row: {
    margin: "0 10px",
  },
  errorIcon: {
    display: "flex",
    alignItems: "center",
  },
  red: {
    color: "red",
  },
  black: {
    color: "#000",
  },
};

export const popStyles: {
  [key: string]: SxProps<Theme>;
} = {
  container: {
    padding: "1rem",
  },
  clearBottan: {
    padding: 0,
    minWidth: "auto",
    lineHeight: "inherit",
  },
};
